<!-- WARN: This dialog and the ContentActivationWarningsDialog are almost 1:1
  copies right now, changing one should likely mean to also update the other.
-->
<template>
  <v-dialog
    lazy
    scrollable
    persistent
    :value="show"
    :width="$store.state.common.largeDialogWidth"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card>
      <v-card-title>
        <v-layout align-center>
          <v-icon
            color="warning"
            class="mr-3"
          >
            warning
          </v-icon>
          <div class="headline">
            {{ $t('selectedContentDeletionWarnings_1') }}
            <span class="grey--text">({{ notDeletedContents.length }})</span>
          </div>
        </v-layout>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-layout column>
          <div class="subheading">
            {{ $t('selectedContentDeletionWarnings_3') }}:
          </div>
          <v-divider class="my-3" />
          <v-layout
            v-for="(content, contentIndex) in notDeletedContents"
            :key="content.id"
            column
          >
            <!-- Content -->
            <spot
              v-if="isSpot(content)"
              :spot="content"
              :ctype="content.ctype"
              :highlight-title-when-selected="false"
              :show-divider="false"
            />
            <tv-spot-bundle
              v-if="isTVSpotBundle(content)"
              :bundle="content"
              :highlight-title-when-selected="false"
            />
            <ticker
              v-if="isTicker(content)"
              :ticker="content"
            />
            <!-- Reasons why its deletion was not possible -->
            <div
              v-for="message in contentIdentToWarningMessages[content.ident]"
              :key="contentIndex + message"
              class="py-1"
              :class="{
                'margin-left-to-align-with-spot-title':
                  $vuetify.breakpoint.smAndUp,
              }"
            >
              <v-layout align-center>
                <v-icon
                  color="warning"
                  class="mr-3"
                >
                  warning
                </v-icon>
                <span v-if="message.key && message.details">
                  {{ $t(message.key, message.details) }}
                </span>
                <span v-else>
                  {{ $t(message) }}
                </span>
              </v-layout>
            </div>
            <v-divider
              v-if="contentIndex < notDeletedContents.length - 1"
              class="my-2"
            />
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <btn-abort
          class="mx-auto"
          round
          :label="$t('okay')"
          data-cy="close-dialog-btn"
          @click="close()"
        />
      </v-card-actions>
      <v-spacer />
    </v-card>
  </v-dialog>
</template>

<script>
import identifiers from '@/mixins/identifiers.js';

import BtnAbort from '@/components/ButtonAbort';
import Spot from '@/components/Spot';
import Ticker from '@/components/Ticker';
import TvSpotBundle from '@/components/TvSpotBundle';

export default {
  components: {
    BtnAbort,
    Spot,
    Ticker,
    TvSpotBundle,
  },
  mixins: [identifiers],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    contents: {
      type: Array[Object],
      required: true,
    },
    /**
     * Array of Objects like: {'ident': ..., 'messages': ['noMatchingTVFormat', ...]}
     *
     * Each message can also be an object with 'key' and 'details' for
     * more complex translations.
     */
    warnings: {
      type: Array[Object],
      required: true,
    },
  },
  computed: {
    contentIdentToWarningMessages() {
      const identToMessages = {};
      for (let warning of this.warnings) {
        const messages = identToMessages[warning.ident];
        if (!messages) {
          identToMessages[warning.ident] = [];
        }
        // Merge messages so that they are unique within the array.
        for (let message of warning.messages) {
          if (identToMessages[warning.ident].indexOf(message) === -1) {
            identToMessages[warning.ident].push(message);
          }
        }
      }
      return identToMessages;
    },
    warningContentIdents() {
      return this.warnings.map((warning) => warning.ident);
    },
    notDeletedContents() {
      return this.contents.filter((content) => {
        return this.warningContentIdents.indexOf(content.ident) !== -1;
      });
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.margin-left-to-align-with-spot-title {
  margin-left: 109px; /* Measured in Spot.vue preview part. */
}
</style>



// WEBPACK FOOTER //
// src/components/ContentDeletionWarningsDialog.vue